export default __webpack_public_path__ + "static/SSSpyView_screenshot-1@mob2x-f8af48b0e42dfdb6eb48056cea8cf5c0.jpg";